/* Andy Cooks – "Recipes you may like": ranks every recipe against the one on screen.
   Score = ingredients (tf-idf cosine) 45% + tags (idf-weighted overlap) 33% + title words 14% + cook time 8%,
   plus a small nudge for well-rated recipes. Data: window.ACIndex (ac-search.js) + /blogs/recipes?view=acing. */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  var root = document.querySelector('[data-acy]');
  if (!root) return;
  var COUNT = +root.getAttribute('data-count') || 10;
  var ING_KEY = 'acIng:v3', ING_TTL = 24 * 3600 * 1000;
  var pv = (location.search.match(/preview_theme_id=\d+/) || [''])[0];

  /* ---------- ingredient lines -> key words ---------- */
  var STOP = ('g kg mg ml l lt litre litres liter liters cl dl oz lb lbs pound pounds tbsp tbs tsp tablespoon tablespoons teaspoon teaspoons cup cups ' +
    'pinch pinches dash handful handfuls bunch bunches sprig sprigs clove cloves can cans tin tins jar jars packet packets pack pkt piece pieces slice slices ' +
    'stick sticks head heads knob splash drizzle sheet sheets fillet fillets stalk stalks leaf leaves large small medium big extra about approx approximately ' +
    'fresh freshly finely roughly thinly thickly coarsely chopped diced sliced minced grated crushed peeled halved quartered trimmed torn shredded julienned ' +
    'cut cubed whole ground cracked melted softened room temperature cold hot warm boiling to taste for serve serving garnish optional plus more extra ' +
    'and or of the a an in into with without on at your any good quality store bought homemade see note notes recipe below above x cm mm inch inches ' +
    'deseeded seeded pitted rinsed drained washed picked removed skin skinless boneless bone in off thick thin wedge wedges zest juice juiced zested ' +
    'heaped level rounded generous few some little lightly well lot ' +
    /* pantry staples nearly every recipe has, so they don't count as "similar" */
    'salt sea flaky kosher pepper black olive oil vegetable canola neutral cooking spray water ice virgin ' +
    /* describing words that say nothing about the dish */
    'greasing extract powder soda bicarb bicarbonate plain self raising caster granulated unsalted salted pure free range dried frozen tinned canned ' +
    'red white brown green yellow dark light double thickened full fat low reduced natural instant fine').split(' ');
  var STOPSET = {}; STOP.forEach(function (w) { STOPSET[w] = 1; });
  var SAME = { chilli: 'chili', chile: 'chili', chillies: 'chili', chilies: 'chili', tomatoe: 'tomato', potatoe: 'potato', mince: 'mince', yoghurt: 'yogurt', capsicum: 'pepper', aubergine: 'eggplant', courgette: 'zucchini', coriander: 'cilantro', prawn: 'shrimp', scallion: 'shallot' };
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) w = w.slice(0, -3) + 'y';
    else if (w.length > 4 && /oes$/.test(w)) w = w.slice(0, -2);
    else if (w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w)) w = w.slice(0, -1);
    return SAME[w] || w;
  }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ''); }
  function words(s) {
    return norm(s).replace(/\([^)]*\)/g, ' ').split(/[^a-z]+/).filter(function (w) { return w.length > 2 && !STOPSET[w]; }).map(stem);
  }
  function ingWords(x) {
    var out = [];
    (x || '').split('|').forEach(function (line) {
      line = line.split(/,| - | – |;/)[0];               /* drop prep notes after a comma */
      words(line).forEach(function (w) { if (out.indexOf(w) < 0) out.push(w); });
    });
    return out;
  }

  function getPages(view) {
    function u(p) { return '/blogs/recipes?view=' + view + '&page=' + p + (pv ? '&' + pv : ''); }
    return fetch(u(1), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetch(u(p), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }));
      return Promise.all(rest).then(function (pages) { return first.items.concat.apply(first.items, pages.map(function (x) { return x.items || []; })); });
    });
  }
  function loadIng() {
    try {
      var c = JSON.parse(localStorage.getItem(ING_KEY) || 'null');
      if (c && Date.now() - c.at < ING_TTL && c.map) return Promise.resolve(c.map);
    } catch (e) {}
    return getPages('acing').then(function (items) {
      var map = {};
      items.forEach(function (it) { map[it.h] = ingWords(it.x).join(' '); });
      try { localStorage.setItem(ING_KEY, JSON.stringify({ at: Date.now(), map: map })); } catch (e) {}
      return map;
    }).catch(function () { return {}; });
  }
  function waitIndex() {
    return new Promise(function (res, rej) {
      var n = 0;
      (function tick() { if (window.ACIndex) return res(window.ACIndex); if (++n > 100) return rej(new Error('no index')); setTimeout(tick, 100); })();
    });
  }

  /* ---------- scoring ---------- */
  var GENERIC = { recipe: 1, recipes: 1, 'andy cooks': 1, video: 1, featured: 1, new: 1, all: 1 };
  function rank(list, ing, curH) {
    var N = list.length, dfI = {}, dfT = {}, dfW = {};
    var docs = list.map(function (r) {
      var I = ing[r.h] ? ing[r.h].split(' ') : [];
      var T = (r.g || []).map(function (t) { return norm(t).trim(); }).filter(function (t) { return t && !GENERIC[t]; });
      var W = words(r.t);
      I.forEach(function (w) { dfI[w] = (dfI[w] || 0) + 1; });
      T.forEach(function (w) { dfT[w] = (dfT[w] || 0) + 1; });
      W.forEach(function (w) { dfW[w] = (dfW[w] || 0) + 1; });
      return { r: r, I: I, T: T, W: W };
    });
    function idf(df, w) { return Math.log(1 + N / (df[w] || 1)); }
    function vec(arr, df) { var v = {}, n = 0; arr.forEach(function (w) { var x = idf(df, w); v[w] = x; n += x * x; }); return { v: v, n: Math.sqrt(n) || 1 }; }
    function cos(a, b) { var s = 0; for (var k in a.v) if (b.v[k]) s += a.v[k] * b.v[k]; return s / (a.n * b.n); }

    var cur = null;
    for (var i = 0; i < docs.length; i++) if (docs[i].r.h === curH) { cur = docs[i]; break; }
    if (!cur) { /* recipe not in the index: fall back to what the page knows */
      var g = (root.getAttribute('data-g') || '').split('|').filter(Boolean);
      cur = { r: { h: curH, m: 0 }, I: [], T: g.map(function (t) { return norm(t).trim(); }).filter(function (t) { return !GENERIC[t]; }), W: words(root.getAttribute('data-t')) };
    }
    var cI = vec(cur.I, dfI), cT = vec(cur.T, dfT), cW = vec(cur.W, dfW);
    var hasI = cur.I.length > 0, curTitle = norm(root.getAttribute('data-t')).trim();
    var out = [];
    docs.forEach(function (d) {
      if (d.r.h === curH || !d.r.u || norm(d.r.t).trim() === curTitle) return;
      var dI = vec(d.I, dfI), dT = vec(d.T, dfT), dW = vec(d.W, dfW);
      var si = hasI && d.I.length ? cos(cI, dI) : 0, st = cos(cT, dT), sw = cos(cW, dW);
      var sm = cur.r.m && d.r.m ? Math.max(0, 1 - Math.abs(Math.log(d.r.m / cur.r.m)) / 1.6) : 0.5;
      var s = hasI ? 0.45 * si + 0.33 * st + 0.14 * sw + 0.08 * sm : 0.6 * st + 0.3 * sw + 0.1 * sm;
      s += 0.03 * Math.min(d.r.rc || 0, 40) / 40 * ((d.r.rv || 0) / 5);
      /* the shared ingredients that matter most, for the "why" line */
      var shared = [];
      if (hasI) for (var k in cI.v) if (dI.v[k]) shared.push([k, cI.v[k]]);
      shared.sort(function (a, b) { return b[1] - a[1]; });
      var sharedTags = d.T.filter(function (t) { return cT.v[t]; }).sort(function (a, b) { return idf(dfT, b) - idf(dfT, a); });
      out.push({ s: s, r: d.r, why: shared.slice(0, 3).map(function (x) { return x[0]; }), tags: sharedTags });
    });
    out.sort(function (a, b) { return b.s - a.s || (b.r.d || 0) - (a.r.d || 0); });
    return out.slice(0, COUNT);
  }

  /* ---------- render ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function listWords(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1]; }
  function whyLine(x) {
    if (x.why.length >= 2) return acT('ac.js.related.also_uses', 'Also uses __items__', { items: listWords(x.why) });
    var t = x.tags.filter(function (t) { return t.length < 22; }).slice(0, 2);
    if (x.why.length === 1 && t.length) return acT('ac.js.related.also_uses', 'Also uses __items__', { items: x.why[0] }) + ' · ' + cap(t[0]);
    if (t.length) return t.map(cap).join(' · ');
    if (x.why.length) return acT('ac.js.related.also_uses', 'Also uses __items__', { items: x.why[0] });
    return '';
  }
  function card(x, i, top) {
    var A = window.ACIndex, r = x.r;
    /* an absolute closeness score, not relative to the top pick */
    var pct = Math.max(60, Math.min(98, Math.round(55 + 90 * x.s)));
    var why = whyLine(x);
    return '<a class="acy-card" href="' + esc(r.u) + '" style="--i:' + i + '">' +
      '<span class="acy-card__img">' + (r.i ? '<img src="' + esc(A.img(r.i, 640)) + '" alt="" loading="lazy" width="640" height="640">' : '') +
      '<span class="acy-card__match"><b>' + pct + '%</b> ' + esc(acT('ac.js.related.match', 'match')) + '</span>' +
      (r.v ? '<span class="acy-card__vid" aria-label="' + esc(acT('ac.js.related.has_video', 'Has video')) + '"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z"/></svg></span>' : '') + '</span>' +
      '<span class="acy-card__body"><span class="acy-card__title">' + esc(r.t) + '</span>' +
      (why ? '<span class="acy-card__why">' + esc(why) + '</span>' : '') +
      '<span class="acy-card__meta">' + (r.m ? '<span class="acy-card__time"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>' + A.mins(r.m) + '</span>' : '') +
      (r.rc ? '<span class="acy-card__rate">' + A.stars(r) + '</span>' : '') + '</span></span></a>';
  }

  var track = root.querySelector('[data-acy-track]'), bar = root.querySelector('[data-acy-bar]');
  var prev = root.querySelector('[data-acy-dir="-1"]'), next = root.querySelector('[data-acy-dir="1"]');
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft > max - 4;
    root.classList.toggle('acy--noscroll', max < 4);
    if (bar) { var w = track.clientWidth / track.scrollWidth; bar.style.width = (w * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (1 / w - 1) * 100 : 0) + '%)'; }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acy-dir]'); if (!b) return;
    var c = track.querySelector('.acy-card'), step = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth;
    var per = Math.max(1, Math.floor((track.clientWidth + 8) / step));
    track.scrollBy({ left: step * per * +b.getAttribute('data-acy-dir'), behavior: 'smooth' });
  });
  track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
  window.addEventListener('resize', sync);

  var started = false;
  function start() {
    if (started) return; started = true;
    root.hidden = false;
    Promise.all([waitIndex().then(function (A) { return A.load(); }), loadIng()]).then(function (res) {
      var top = rank(res[0], res[1], root.getAttribute('data-h'));
      if (!top.length) { root.hidden = true; return; }
      var best = top[0].s;
      track.innerHTML = top.map(function (x, i) { return card(x, i, best); }).join('');
      root.__acy = top.map(function (x) { return [Math.round(x.s * 1000) / 1000, x.r.t]; });
      root.classList.add('is-ready');
      sync();
    }).catch(function () { root.hidden = true; });
  }
  /* show the skeleton straight away but only fetch once the reader is heading down the page */
  root.hidden = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '1200px 0px' });
    io.observe(root);
  } else start();
  function near() { if (root.getBoundingClientRect().top < window.innerHeight + 1200) { window.removeEventListener('scroll', near); start(); } }
  window.addEventListener('scroll', near, { passive: true });
})();
